import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useAuth, API_URL } from '../../context/AuthContext';

export default function CambiarPasswordForzado() {
  const { usuario, actualizarUsuario } = useAuth();
  const navigate = useNavigate();
  const [password, setPassword] = useState('');
  const [confirmar, setConfirmar] = useState('');
  const [guardando, setGuardando] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (password !== confirmar) return setError('Las contraseñas no coinciden');
    if (password.length < 6) return setError('Mínimo 6 caracteres');
    setGuardando(true);
    try {
      await axios.put(`${API_URL}/auth/cambiar-password-forzado`, { password_nuevo: password });
      actualizarUsuario({ ...usuario, forzar_cambio_password: false });
      navigate(usuario?.rol === 'admin' ? '/admin' : '/seleccion', { replace: true });
    } catch (e) {
      setError(e.response?.data?.error || 'Error al actualizar la contraseña');
    } finally { setGuardando(false); }
  };

  return (
    <div style={{ minHeight: '100vh', background: '#FFF0F5', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '24px' }}>
      <div style={{ background: '#FFFFFF', border: '1px solid #FBCFE8', borderRadius: '20px', padding: '40px 36px', maxWidth: '420px', width: '100%', boxShadow: '0 8px 32px rgba(236,72,153,0.12)' }}>
        <div style={{ textAlign: 'center', marginBottom: '28px' }}>
          <div style={{ fontSize: '40px', marginBottom: '12px' }}>🔑</div>
          <h1 style={{ color: '#581C47', fontSize: '22px', marginBottom: '8px' }}>Cambia tu contraseña</h1>
          <p style={{ color: '#BE84A3', fontSize: '14px' }}>El administrador requiere que establezcas una nueva contraseña antes de continuar.</p>
        </div>

        {error && (
          <div style={{ background: 'rgba(236,72,153,0.08)', border: '1px solid rgba(236,72,153,0.25)', borderRadius: '10px', padding: '10px 14px', color: '#DB2777', fontSize: '13px', marginBottom: '16px' }}>{error}</div>
        )}

        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: '14px' }}>
            <label style={{ color: '#BE84A3', fontSize: '12px', display: 'block', marginBottom: '6px' }}>Nueva contraseña</label>
            <input
              type="password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              required
              placeholder="Mínimo 6 caracteres"
              style={{ width: '100%', padding: '12px 14px', borderRadius: '10px', background: '#FFF0F5', border: '1px solid #FBCFE8', color: '#581C47', fontSize: '14px' }}
            />
          </div>
          <div style={{ marginBottom: '24px' }}>
            <label style={{ color: '#BE84A3', fontSize: '12px', display: 'block', marginBottom: '6px' }}>Confirmar contraseña</label>
            <input
              type="password"
              value={confirmar}
              onChange={e => setConfirmar(e.target.value)}
              required
              placeholder="Repite la contraseña"
              style={{ width: '100%', padding: '12px 14px', borderRadius: '10px', background: '#FFF0F5', border: '1px solid #FBCFE8', color: '#581C47', fontSize: '14px' }}
            />
          </div>
          <button
            type="submit"
            disabled={guardando}
            style={{ width: '100%', background: 'linear-gradient(135deg, #EC4899 0%, #F472B6 100%)', border: 'none', color: '#fff', padding: '13px', borderRadius: '50px', fontSize: '15px', fontWeight: 700, cursor: guardando ? 'not-allowed' : 'pointer', opacity: guardando ? 0.6 : 1, boxShadow: '0 4px 14px rgba(236,72,153,0.35)' }}
          >
            {guardando ? 'Guardando...' : 'Establecer contraseña'}
          </button>
        </form>
      </div>
    </div>
  );
}
